<template>
  <div class="layout__padding-clear layout__width-80">
    <div class="">
      <CustomerOrdersSearch
        :searchParams="searchParams"
        :orders="orders"
        :view="view"
        :loading="loading"
      />
    </div>
    <div class="layout__width-100 layout__position-left">
      <el-table
        :data="orders"
        width="100"
        class="mb-20 vouchers-table"
        v-loading="loading"
      >
        <el-table-column
          prop="orderId"
          width="150px"
          label="Order Id"
        />
        <!-- <el-table-column label="Order Ref">
            <template slot-scope="props">
                <div v-if="props.row.source === 'BESPOKE'">{{props.row.jobName}}</div>
                <div v-else>{{props.row.billDescription}}</div>
            </template>
        </el-table-column> -->
        <el-table-column
          prop="source"
          label="Order Ref"
          width="200px"
          :formatter="formatOrderRef"
        />
        <el-table-column
          prop="customerRef"
          width="200px"
          label="Customer Ref"
        />
        <el-table-column
          prop="status"
          label="Status"
          width="100px"
        />
        <el-table-column
          prop="quantity"
          label="Qty"
          width="100px"
        />
        <el-table-column
          prop="type"
          label="Product"
          width="150px"
          :formatter="formatProductType"
        />
        <el-table-column
          prop="billGrossTotal"
          label="Net Total (GBP)"
          width="150px"
          :formatter="returnCurrency"
        />
        <el-table-column
          label="Download Artwork"
          width="150px"
        >
          <template slot-scope="props">
            <div
              v-if="props.row && props.row.jobFilename"
              class="layout__padding-clear"
            >
              <img
                class="layout__width-20px layout__position-center"
                src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/download.png"
                alt=""
                @click="downloadPdf(props.row)"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="creatorUser"
          label="User info"
          width="200px"
          :formatter="(row, column, cellValue) => cellValue || 'N/A'"
        />
      </el-table>
    </div>

    <div class="layout__padding-clear layout__width-60">
      <div class="layout__padding-20-0">
        <el-pagination
          class="layout__padding-clear"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="this.searchParams.currentPage"
          :page-sizes="[20, 40, 60, 80, 100]"
          :page-size="this.searchParams.pagination"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.resultsCount"
        />
      </div>
    </div>

  </div>

</template>

<script>
import CustomerOrdersSearch from '../../components/search/CustomerOrdersSearch';
import Pagination from '../../components/Pagination';
import { dataFormatter } from '@/mixins/DataFormatter.js';
import { csvDownloadHelper } from '@/mixins/CsvDownloadHelper.js';
import { pagination } from '@/mixins/Pagination.js';

export default {
  name: 'emailOrders',
  mixins: [csvDownloadHelper, dataFormatter, pagination],
  components: {
    Pagination,
    CustomerOrdersSearch
  },
  data() {
    return {
      resultsCount: 0,
      orders: [],
      loading: false,
      searchParams: {},
      view: 'All',
    };
  },
  methods: {
    resultsPerPage() {
      document.getElementById('getCustomerOrdersPagination').click();
    },

    downloadPdf(artwork) {
      const { jobFilename } = artwork;

      event.stopPropagation();

      const link = document.createElement('a');

      link.href = jobFilename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      event.stopPropagation();
    },
  }
};
</script>